import { createSlice } from '@reduxjs/toolkit';

import { breakpoints } from '~/common/utils/breakpoint.utils';
import { getStoredThemeMode } from '~/common/utils/theme.util';

import type { PayloadAction } from '@reduxjs/toolkit';

import type { ModalName } from '~/common/types/modal.type';
import type { ThemeMode } from '~/common/types/theme.type';

export interface LayoutState {
  activeModals: ModalName[];
  themeMode: ThemeMode;

  isLoading: boolean;
  isNavBarActive: boolean;
  isSidebarActive: boolean;
}

/**
 * 화면 크기에 따라 사이드바 초기 상태 결정
 * - 데스크탑 (768px 이상): true (열림)
 * - 모바일 (768px 미만): false (닫힘)
 */
const getInitialSidebarState = (): boolean => {
  if (typeof window === 'undefined') return true;
  return window.innerWidth >= breakpoints.md;
};

const initialState: LayoutState = {
  activeModals: [],
  themeMode: getStoredThemeMode(),

  isLoading: false,
  isNavBarActive: true,
  isSidebarActive: getInitialSidebarState(),
};

const LayoutSlice = createSlice({
  initialState,
  name: 'layout',
  reducers: {
    closeAllModals: state => {
      state.activeModals = [];
    },
    closeModal: (state, action: PayloadAction<ModalName>) => {
      if (state.activeModals.includes(action.payload)) {
        state.activeModals = state.activeModals.filter(modal => modal !== action.payload);
      }
    },
    openModal: (state, action: PayloadAction<ModalName>) => {
      state.activeModals.push(action.payload);
    },

    toggleLoading(state, action: PayloadAction<LayoutState['isLoading']>) {
      state.isLoading = action.payload;
    },
  },
});

export const { closeAllModals, closeModal, openModal, toggleLoading } = LayoutSlice.actions;
export default LayoutSlice;
